import Api from './Api.service';

export default class ComisionPlanificacionService {

    static ObtenerComiPlaniConfig(semestreId) {
        return Api.get(`/comisionplani/config/distancia/${semestreId}`);
    }
    static ActualizarComiPlani(body) {
        return Api.post(`/comisionplani/config/`,body);
    }

}